import { activities, postBiometrics, putBiometrics, resendcode, signup, verifyUser } from '../api'
import { saveToken, saveUser } from '../../services/authService'

export const doSignUp = ({ commit, dispatch }, data) => {
  if (data.hasOwnProperty('agreeTerms') === true && data.agreeTerms === true) {
    data.agreeTerms = new Date()
  }
  return signup(data).then(async (res) => {
    const statusString = res.status.toString()
    if (statusString.charAt(0) === '2') {
      await saveUser('user', res.data)
      commit('SIGNEDUP', true)
    }
  }).catch((err) => {
    dispatch('checkNested', { obj: err, props: ['response', 'data'] }).then((res) => {
      commit('SIGNUPERROR', res)
    })
  })
}

export const doResendCode = ({ commit, dispatch }, data) => {
  return resendcode(data).then(async (res) => {
    commit('CODESENT', true)
  }).catch((err) => {
    console.log(err)
  })
}

export const doVerify = async ({ commit, dispatch }, data) => {
  data.password2 = data.password || null
  try {
    const res = await verifyUser(data)
    if (res.hasOwnProperty('access_token') === true) {
      await saveToken('token', res)
      commit('LOGIN', res)

      commit('VERIFIED', true)
      commit('TOAST_VERIFY', 'Successfuly verified!')
      return res
    }
  } catch (err) {
    dispatch('checkNested', { obj: err, props: ['response', 'data'] }).then((res) => {
      commit('SIGNUPERROR', res.msg)
    })
  }
}
export const loadBiometrics = async ({ commit, dispatch }) => {
  try {
    const res = await dispatch('getActivities')
    commit('BIOMETRICSFIELDSET', res)
  } catch (err) {
    dispatch('checkNested', { obj: err, props: ['response', 'data'] }).then((res) => {
      commit('EXAMPLE_ERROR', res)
    })
  }
}

export const doEnterBiometrics = ({ commit, dispatch }, data) => {
  if (data._id) {
    return putBiometrics(data, data._id).then((res) => {
      const statusString = res.status.toString()
      if (statusString.charAt(0) === '2') {
        commit('BIOMETRICSENTERED', true)
      }
    }).catch((err) => {
      commit('BIOMETRICSENTERED', true)
      dispatch('checkNested', { obj: err, props: ['response', 'data'] }).then((res) => {
        commit('BIOMETRICSERROR', res)
      })
    })
  } else {
    return postBiometrics(data).then((res) => {
      const statusString = res.status.toString()
      if (statusString.charAt(0) === '2') {
        commit('BIOMETRICSENTERED', true)
      }
    }).catch((err) => {
      commit('BIOMETRICSENTERED', true)
      dispatch('checkNested', { obj: err, props: ['response', 'data'] }).then((res) => {
        commit('BIOMETRICSERROR', res)
      })
    })
  }
}

export const getActivities = ({ commit, dispatch }, data) => {
  return activities().then((res) => {
    const statusString = res.status.toString()
    if (statusString.charAt(0) === '2') {
      return dispatch('checkNested', { obj: res, props: ['data', 'results'] }).then((allActivities) => {
        return allActivities
      })
    }
  }).catch((err) => {
    console.log(err)
  })
}



// WEBPACK FOOTER //
// ./src/app/store/signup/actions.js